import type { CheckoutBridgeService } from './bridge'
import type { CheckoutBusService } from './bus'
import type { CheckoutCarRentalService } from './carRental'
import type { CheckoutClothingService } from './clothing'
import type { CheckoutDinnerVouchersService } from './dinnerVouchers'
import type { CheckoutGolfService } from './golf'
import type { CheckoutLuggageService } from './luggage'
import type { CheckoutPerBookingService } from './perBooking'
import type { CheckoutPerParticipantService } from './perParticipant'
import type { CheckoutPerRoomService } from './perRoom'
import type { CheckoutBookingRedeemerService } from './redeemer'
import type { CheckoutSkiAncillaryService } from './ski'

export enum ServiceType {
  CarRentalFiltering = 'carRentalFiltering',
  TravelInsurance = 'travelInsurance',
  TravelInsurancePerBooking = 'travelInsurancePerBooking',
  CancellationInsurance = 'cancellationInsurance',
  CancellationInsurancePerBooking = 'cancellationInsurancePerBooking',
  Bus = 'bus',
  MealplanDP = 'mealplanDP',
  Luggage = 'luggage',
  BookingRedeem = 'bookingRedeem',
  SkiPass = 'skiPass',
  SkiMaterial = 'skiMaterial',
  SkiLesson = 'skiLesson',
  Sweater = 'sweater',
  TShirt = 'tShirt',
  Golf = 'golf',
  DinnerVouchers = 'dinnerVouchers',
  Bridge = 'bridge',
  GenericServicePerBooking = 'genericServicePerBooking',
  GenericServicePerParticipant = 'genericServicePerParticipant',
  GenericServicePerRoom = 'genericServicePerRoom',
}

export interface CheckoutService {
  id: string
  isSelected: boolean
  type: ServiceType
}

export interface Services {
  [ServiceType.CarRentalFiltering]: CheckoutCarRentalService
  [ServiceType.TravelInsurance]: CheckoutPerParticipantService
  [ServiceType.TravelInsurancePerBooking]: CheckoutPerBookingService
  [ServiceType.CancellationInsurance]: CheckoutPerBookingService
  [ServiceType.CancellationInsurancePerBooking]: CheckoutPerBookingService
  [ServiceType.MealplanDP]: CheckoutPerRoomService
  [ServiceType.Luggage]: CheckoutLuggageService
  [ServiceType.BookingRedeem]: CheckoutBookingRedeemerService
  [ServiceType.SkiPass]: CheckoutSkiAncillaryService
  [ServiceType.SkiMaterial]: CheckoutSkiAncillaryService
  [ServiceType.SkiLesson]: CheckoutSkiAncillaryService
  [ServiceType.Sweater]: CheckoutClothingService
  [ServiceType.TShirt]: CheckoutClothingService
  [ServiceType.Bus]: CheckoutBusService
  [ServiceType.Golf]: CheckoutGolfService
  [ServiceType.Bridge]: CheckoutBridgeService
  [ServiceType.DinnerVouchers]: CheckoutDinnerVouchersService
  [ServiceType.GenericServicePerBooking]: CheckoutPerBookingService
  [ServiceType.GenericServicePerParticipant]: CheckoutPerParticipantService
  [ServiceType.GenericServicePerRoom]: CheckoutPerRoomService
}

export * from './bridge'
export * from './bus'
export * from './carRental'
export * from './clothing'
export * from './common'
export * from './dinnerVouchers'
export * from './golf'
export * from './luggage'
export * from './perBooking'
export * from './perParticipant'
export * from './perRoom'
export * from './redeemer'
export * from './ski'
